import React, {useState} from 'react'
import {Drawer, Box} from '@mui/material'

function LanguageSwitcher(props) {
  const langs = ["ita", "eng", "spa", "deu"]
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { setLanguage, selectedLanguage } = props;

  const style = {
    container: {
      display: "flex", 
      justifyContent: "flex-end",
      width: "100%"
    },
    image: {
      display: "flex",
      borderRadius: "4px",
      padding: "1rem"
    },
    images:{
      display: "flex",
      justifyContent: "space-around"
    }
  }

  const toggleDrawer = (open) => (event) => {
      if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
      }
      setDrawerOpen(open);
  };

  return (
    <div style={style.container}>
      <div>
        <img 
          style={style.image} 
          src={`./images/flags/${selectedLanguage}.png`} 
          onClick={toggleDrawer(true)}
        />
      </div>
      <Drawer anchor="bottom" open={drawerOpen} onClose={toggleDrawer(false)}>
          <Box role="presentation" sx={style.images}>
            {langs.map((l)=>
               (<div key={l}>
                  <img 
                    style={style.image} 
                    src={`./images/flags/${l}.png`} 
                    onClick={ ()=>{
                      setDrawerOpen(false);
                      setLanguage(l)
                      }
                    }
                  />
                </div>)
            )}
          </Box>
      </Drawer>
    </div>
  )
}
export default LanguageSwitcher